export class StockOut {
    id = null;
    department = null;
    fromDate = null;
    toDate = null;
    isExported = null;
    items = [];
    stockOutDate = null;

}